// Session lifecycle: enroll, restore, logout.

import { api } from '../api.js';
import { state, notify } from '../state.js';
import {
  clearAll, getDeviceMeta, getDeviceToken, getOrCreateFingerprint,
  setDeviceMeta, setDeviceToken
} from '../storage.js';
import { PWA_VERSION } from '../version.js';

export function restoreSession() {
  const token = getDeviceToken();
  const meta = getDeviceMeta();
  if (token && meta) {
    state.deviceToken = token;
    state.deviceMeta = meta;
    return true;
  }
  return false;
}

/**
 * Submit either an enrollment token (from QR URL) or a short code.
 * Returns the device meta on success, throws on failure.
 */
export async function enroll({ enrollmentToken, shortCode }) {
  const payload = {
    enrollmentToken: enrollmentToken || null,
    shortCode: shortCode || null,
    fingerprint: getOrCreateFingerprint(),
    userAgent: navigator.userAgent,
    pwaVersion: PWA_VERSION,
    lat: state.lastGps?.lat ?? null,
    lng: state.lastGps?.lng ?? null,
    gpsGranted: state.gpsGranted
  };
  const res = await api.enroll(payload);
  if (!res?.success || !res.result) {
    throw new Error(res?.message || 'No se pudo matricular el dispositivo.');
  }
  const r = res.result;
  setDeviceToken(r.deviceToken);
  const meta = {
    deviceId: r.deviceId,
    companyId: r.companyId,
    companyName: r.companyName ?? null,
    deviceName: r.deviceName
  };
  setDeviceMeta(meta);
  state.deviceToken = r.deviceToken;
  state.deviceMeta = meta;
  notify();
  return meta;
}

export async function logout() {
  await clearAll();
  state.deviceToken = null;
  state.deviceMeta = null;
  state.view = 'enroll';
  state.message = null;
  state.pendingQueueCount = 0;
  state.candidate = null;
  state.inputDigits = '';
  notify();
}
